export default __webpack_public_path__ + "static/media/tempo-mid.56a76a4c.svg";